import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/shell/app-shell";
import { useAuth } from "@/hooks/use-auth";
import { SignInPage } from "@/pages/sign-in";
import { AuthCallbackPage } from "@/pages/auth-callback";
import { DashboardPage } from "@/pages/dashboard";
import { LeadsPage } from "@/pages/leads";
import { HandoffsPage } from "@/pages/handoffs";
import { CoursesPage } from "@/pages/courses";
import { GroupsPage } from "@/pages/groups";
import { RulesPage } from "@/pages/rules";
import { KnowledgePage } from "@/pages/knowledge";
import { InstructionsPage } from "@/pages/instructions";
import { ChatTesterPage } from "@/pages/chat-tester";
import { ConfigPage } from "@/pages/config";
import { AdminsPage } from "@/pages/admins";
import { PreferencesPage } from "@/pages/preferences";
import { NotFoundPage } from "@/pages/placeholders";
import { Skeleton } from "@/components/ui/skeleton";

function ProtectedShell() {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div className="min-h-screen grid place-items-center bg-bg">
        <div className="w-full max-w-sm space-y-3 px-6">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
      </div>
    );
  }
  if (status === "anonymous") {
    return <Navigate to="/sign-in" replace />;
  }
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route element={<ProtectedShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/handoffs" element={<HandoffsPage />} />
        <Route path="/chat" element={<ChatTesterPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/rules" element={<RulesPage />} />
        <Route path="/knowledge" element={<KnowledgePage />} />
        <Route path="/instructions" element={<InstructionsPage />} />
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/admins" element={<AdminsPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
